import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import TooltipFetchedObject from 'automation-ui-formula-editor/data-passing-panel/Inputs/tooltip/TooltipFetchedObject';
import TooltipActionOutput from 'automation-ui-formula-editor/data-passing-panel/Inputs/tooltip/TooltipActionOutput';
import TooltipEnrolledObject from 'automation-ui-formula-editor/data-passing-panel/Inputs/tooltip/TooltipEnrolledObject';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyTagTooltip = ({
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    dataSourceDefinition,
    dataSourceProperty
  } = data;
  const {
    dataSourceType
  } = dataSourceDefinition;
  if (!dataSourceProperty) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [dataSourceType === DataSourceType.FETCHED_OBJECT && /*#__PURE__*/_jsx(TooltipFetchedObject, {
      dataSourceDefinition: dataSourceDefinition,
      dataSourceProperty: dataSourceProperty
    }), dataSourceType === DataSourceType.ACTION_OUTPUT && /*#__PURE__*/_jsx(TooltipActionOutput, {
      dataSourceDefinition: dataSourceDefinition,
      dataSourceProperty: dataSourceProperty
    }), (dataSourceType === DataSourceType.DATA_FIELDS || dataSourceType === DataSourceType.ENROLLMENT_DATASET_COLUMN) && /*#__PURE__*/_jsx(TooltipEnrolledObject, {
      dataSourceDefinition: dataSourceDefinition,
      dataSourceProperty: dataSourceProperty
    })]
  });
};
export default PropertyTagTooltip;